import React, {PropTypes} from 'react';
import FontAwesome from 'react-fontawesome';

const Loading = ({loading, size, className}) => {
  if(loading) {
    return (
      <span className={className}>
        &emsp;
        <FontAwesome className="loading-indicator-icon"
          name="spinner"
          size={size}
          pulse />
      </span>
    );
  } else {
    return null;
  }
};

// Note that this odd style is utilized for propType validation for now. Must be defined *after*
// the component is defined, which is why it's separate and down here.
Loading.propTypes = {
  loading: PropTypes.bool,
  size: PropTypes.string,
  className: PropTypes.string,
};

export default Loading;



/** WEBPACK FOOTER **
 ** ./src/components/Loading.js
 **/